import { ReactElement } from 'react';

export function People(): ReactElement {
  return (
    <>
      <div className="banner-bottom">
        <div className="container people">
          <h2>Researchers and Co-Leaders</h2>
          <div className="banner-bottom-left">
            <a href="http://www.cse.ust.hk/faculty/scc/">
              <div className="portrait scc"></div>
            </a>
            <h3>
              <a href="http://www.cse.ust.hk/faculty/scc/">Shing-Chi Cheung</a>
            </h3>
            <p>Chair Professor at HKUST</p>
          </div>
          <div className="banner-bottom-left">
            <a href="http://cs.nju.edu.cn/changxu/">
              <div className="portrait chang"></div>
            </a>

            <h3>
              <a href="http://cs.nju.edu.cn/changxu/">Chang Xu</a>
            </h3>
            <p>Professor at NJU</p>
          </div>
          <div className="banner-bottom-left">
            <a href="http://yepangliu.github.io/">
              <div className="portrait yepang"></div>
            </a>
            <h3>
              <a href="http://yepangliu.github.io/">Yepang Liu</a>
            </h3>
            <p>Associate Professor at SUSTech</p>
          </div>
          <div className="banner-bottom-left">
            <a href="https://wurongxin1987.github.io/wurongxin.xmu.edu.cn">
              <div className="portrait rongxin"></div>
            </a>

            <h3>
              <a href="https://wurongxin1987.github.io/wurongxin.xmu.edu.cn">
                Rongxin Wu
              </a>
            </h3>
            <p>Associate Professor at Xiamen University</p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://justinwm.github.io">
              <div className="portrait ming"></div>
            </a>

            <h3>
              <a href="https://mingwen-cs.github.io/">Ming Wen</a>
            </h3>
            <p>Associate Professor at HUST</p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://valerio65.github.io/">
              <div className="portrait valerio"></div>
            </a>
            <h3>
              <a href="https://valerio65.github.io/">Valerio Terragni</a>
            </h3>
            <p>Senior Lecturer at The University of Auckland</p>
          </div>
          <div className="banner-bottom-left">
            <a href="http://ics.nju.edu.cn/~jyy/">
              <div className="portrait yanyan"></div>
            </a>

            <h3>
              <a href="http://ics.nju.edu.cn/~jyy/">Yanyan Jiang</a>
            </h3>
            <p>Associate Researcher at NJU</p>
          </div>

          <div className="banner-bottom-left">
            <a href="http://faculty.neu.edu.cn/swc/wangying/">
              <div className="portrait yingying"></div>
            </a>

            <h3>
              <a href="http://faculty.neu.edu.cn/swc/wangying/">Ying Wang</a>
            </h3>
            <p>Associate Professor at NEU</p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://mijungk.github.io/">
              <div className="portrait mijung"></div>
            </a>

            <h3>
              <a href="https://mijungk.github.io/">Mijung Kim</a>
            </h3>
            <p>Assistant Professor at UNIST</p>
          </div>
          <div className="banner-bottom-left">
            <a href="https://liliweise.github.io/">
              <div className="portrait lili"></div>
            </a>

            <h3>
              <a href="https://liliweise.github.io/">Lili Wei</a>
            </h3>
            <p>Assistant Professor at McGill University</p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://yqtianust.github.io/">
              <div className="portrait yongqiang"></div>
            </a>

            <h3>
              <a href="http://yqtian.com">Yongqiang Tian</a>
            </h3>
            <p>Assistant Professor at Monash University</p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://huaxunhuang.github.io">
              <div className="portrait huaxun"></div>
            </a>

            <h3>
              <a href="https://huaxunhuang.github.io">Huaxun Huang</a>
            </h3>
            <p>Assistant Professor at Xiamen University</p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://jialuncao.github.io/">
              <div className="portrait">
                <img alt="" src="images/cao.jpg" className="portrait-round" />
              </div>
            </a>

            <h3>
              <a href="https://jialuncao.github.io/">Jialun Cao</a>
            </h3>
            <p>Research Assistant Professor at HKUST</p>
          </div>

          {/*  Students  */}

          <div className="clearfix"> </div>
          <h2>Students</h2>

          <div className="banner-bottom-left">
            <div className="portrait">
              <img alt="" src="images/luliu.png" className="portrait-round" />
            </div>
            <h3>
              <a href="https://liuluuuu.github.io/">Lu Liu</a>
            </h3>
            <p>PhD Student at HKUST</p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://maybelee.github.io/">
              <div className="portrait">
                <img
                  alt=""
                  src="images/ziniu2.jpeg"
                  className="portrait-round"
                />
              </div>
            </a>
            <h3>
              <a href="https://maybelee.github.io/">Meiziniu Li</a>
            </h3>
            <p>PhD Student at HKUST</p>
          </div>

          <div className="banner-bottom-left">
            <div className="portrait">
              <img alt="" src="images/tsz-on.jpg" className="portrait-round" />
            </div>
            <h3>Tsz On Li</h3>
            <p>PhD Student at HKUST</p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://corazona-chen.github.io">
              <div className="portrait">
                <img
                  alt=""
                  src="images/XiaoCHEN.jpg"
                  className="portrait-round"
                />
              </div>
            </a>
            <h3>
              <a href="https://corazona-chen.github.io">Xiao Chen</a>
            </h3>
            <p>PhD Student at HKUST</p>
          </div>

          <div className="banner-bottom-left">
            <div className="portrait">
              <img
                alt=""
                src="images/lixiaolei.jpg"
                className="portrait-round"
              />
            </div>
            <h3>Xiaolei Li</h3>
            <p>PhD Student at HKUST</p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://imcsq.github.io/">
              <div className="portrait">
                <img
                  alt=""
                  src="images/songqiang.png"
                  className="portrait-round"
                />
              </div>
            </a>
            <h3>
              <a href="https://imcsq.github.io/">Songqiang Chen</a>
            </h3>
            <p>PhD Student at HKUST</p>
          </div>

          <div className="banner-bottom-left">
            <div className="portrait">
              <img alt="" src="images/weiqi.png" className="portrait-round" />
            </div>
            <h3>
              <a href="https://williamlus.github.io/">Weiqi Lu</a>
            </h3>

            <p>PhD Student at HKUST</p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://zxhelaine.com">
              <div className="portrait">
                <img
                  alt=""
                  src="images/xiaohan.jpg"
                  className="portrait-round"
                />
              </div>
            </a>
            <h3>
              <a href="https://zxhelaine.com">Xiaohan Zhong</a>
            </h3>
            <p>PhD Student at HKUST</p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://jingyi-a-chen.github.io/">
              <div className="portrait">
                <img
                  alt=""
                  src="images/jingyi.jpg"
                  className="portrait-round"
                />
              </div>
            </a>
            <h3>
              <a href="https://jingyi-a-chen.github.io/">Jingyi Chen</a>
            </h3>
            <p>PhD Student at HKUST</p>
          </div>

          <div className="banner-bottom-left">
            <div className="portrait">
              <img
                alt=""
                src="images/hauching.jpg"
                className="portrait-round"
              />
            </div>
            <h3>Hau Ching Lo</h3>
            <p>MPhil Student at HKUST</p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://github.com/dlibk">
              <div className="portrait">
                <img
                  alt=""
                  src="images/dongze.jpg"
                  className="portrait-round"
                />
              </div>
            </a>
            <h3>
              <a href="https://github.com/dlibk">Dongze Li</a>
            </h3>
            <p>PhD Student at HKUST</p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://zongyiLyu.github.io/">
              <div className="portrait">
                <img
                  alt=""
                  src="images/zongyiLyu.jpg"
                  className="portrait-round"
                />
              </div>
            </a>
            <h3>
              <a href="https://zongyiLyu.github.io/">Zongyi Lyu</a>
            </h3>
            <p>PhD Student at HKUST</p>
          </div>

          {/* Former Members */}
          <div className="clearfix"> </div>
          <h2>Former Members</h2>

          <div className="banner-bottom-left">
            <a href="https://congyingxu.github.io/">
              <div className="portrait">
                <img
                  alt=""
                  src="images/congying.jpeg"
                  className="portrait-round"
                />
              </div>
            </a>
            <h3>
              <a href="https://congyingxu.github.io/">Congying Xu</a>
            </h3>
            <p>PhD Graduate at HKUST</p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://www.linkedin.com/in/haoyang-ma-lyr/">
              <div className="portrait">
                <img
                  alt=""
                  src="images/haoyang.jpg"
                  className="portrait-round"
                />
              </div>
            </a>
            <h3>
              <a href="https://www.linkedin.com/in/haoyang-ma-lyr/">
                Haoyang Ma
              </a>
            </h3>
            <p>PhD 2025; Research Engineer at ByteDance</p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://scholar.henryhc.net/">
              <div className="portrait">
                <img
                  alt=""
                  src="images/hengcheng.png"
                  className="portrait-round"
                />
              </div>
            </a>
            <h3>
              <a href="https://scholar.henryhc.net/">Hengcheng Zhu</a>
            </h3>
            <p>
              PhD 2025; PostDoc at <a href="https://cispa.de/">CISPA</a>
            </p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://sissel-wu.github.io">
              <div className="portrait">
                <img
                  alt=""
                  src="images/jiarong.png"
                  className="portrait-round"
                />
              </div>
            </a>
            <h3>
              <a href="https://sissel-wu.github.io">Jiarong Wu</a>
            </h3>
            <p>PhD Graduate at HKUST</p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://troublor.xyz">
              <div className="portrait">
                <img alt="" src="images/wuqi.jpg" className="portrait-round" />
              </div>
            </a>
            <h3 style={{ marginTop: '0' }}>
              <a href="https://troublor.xyz">
                <span>William Cheung</span>
                <br />
                <span style={{ fontSize: '0.7em' }}>(Wuqi Zhang, 张无奇)</span>
              </a>
            </h3>
            <p>PhD Graduate at HKUST; Research Scholar at Purdue</p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://home.cse.ust.hk/~jhuao/">
              <div className="portrait jiajun"></div>
            </a>

            <h3>
              <a href="https://home.cse.ust.hk/~jhuao/">Jiajun Hu</a>
            </h3>
            <p>PhD Graduate at HKUST</p>
          </div>

          <div className="banner-bottom-left">
            <a href="https://github.com/Derppening/">
              <div className="portrait">
                <img alt="" src="images/david.jpg" className="portrait-round" />
              </div>
            </a>
            <h3>
              <a href="https://github.com/Derppening/">David Mak</a>
            </h3>
            <p>MPhil Graduate. Ph.D. Student at TACO Lab, HKUST</p>
          </div>

          <div className="banner-bottom-left">
            <div className="portrait">
              <img alt="" src="images/quan.jpg" className="portrait-round" />
            </div>
            <h3>Yuqing Quan</h3>
            <p>MPhil Graduate</p>
          </div>

          <div className="banner-bottom-left">
            <div className="portrait eric"></div>

            <h3>Tzu-Yang Kuo</h3>
            <p>Undergraduate Student. Now at Google</p>
          </div>

          <div className="banner-bottom-left">
            <a href="http://moon.nju.edu.cn/spar/peoples/whyang/">
              <div className="portrait wenhua"></div>
            </a>

            <h3>
              <a href="http://moon.nju.edu.cn/spar/peoples/whyang/">
                Wenhua Yang
              </a>
            </h3>
            <p>Assistant Professor at NUAA</p>
          </div>
          <div className="banner-bottom-left">
            <a href="https://www.linkedin.com/in/yueqi-li-aba8011b">
              <div className="portrait yueqi"></div>
            </a>

            <h3>
              <a href="https://www.linkedin.com/in/yueqi-li-aba8011b">
                Yueqi Li
              </a>
            </h3>
            <p>PhD Graduate now at Google</p>
          </div>
          <div className="banner-bottom-left">
            <a href="https://hk.linkedin.com/in/wanjun-chen-92b6068a">
              <div className="portrait melody"></div>
            </a>

            <h3>
              <a href="https://hk.linkedin.com/in/wanjun-chen-92b6068a">
                Wanjun Chen
              </a>
            </h3>
            <p>MPhil Graduate. Now at Daimler Greater China Ltd.</p>
          </div>
          <div className="banner-bottom-left">
            {/*  <a href="">  */}
            <div className="portrait xueliang"></div>

            <h3>Xueliang Li</h3>
            <p>Visiting Student from Roskilde University</p>
          </div>

          <div className="banner-bottom-left">
            <div className="portrait">
              <img alt="" src="images/hangxu.png" className="portrait-round" />
            </div>

            <h3>Hang Xu</h3>
            <p>MPhil Graduate</p>
          </div>

          <div className="clearfix"> </div>
        </div>
      </div>
    </>
  );
}
